module.exports = __webpack_public_path__ + "static/img/hmgt_no_house.81a5401.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/state/hmgt_no_house.svg
// module id = vOxx
// module chunks = 30